import React, {useState} from "react";
import {useAlert} from "react-alert";
import {CommonHelper} from "../CommonHelper";

interface BYExportButtonsTableProps {
    data: string[][];
    title: string;
}

const BYExportButtonsTable = ({data, title}: BYExportButtonsTableProps) => {
    const [loading, setLoading] = useState(false);
    const alert = useAlert();

    return <div className="form-inline d-inline-flex">
        <div className="btn-group btn-group-sm">
            <button type="button" className="btn btn-sm btn-primary"
                    disabled={loading}
                    onClick={async () => {
                        setLoading(true);

                        try {
                            await CommonHelper.downloadPDF(data, `${title}.pdf`, title);
                        } catch (e) {
                            alert.error(e.message);
                        }
                        setLoading(false);
                    }}>
                <i className="fa fa-print"></i>
            </button>
            <button type="button" className="btn btn-sm btn-secondary"
                    disabled={loading}
                    onClick={async () => {
                        setLoading(true);

                        try {
                            CommonHelper.downloadCSV(data, `${title}.csv`);
                        } catch (e) {
                            alert.error(e.message);
                        }
                        setLoading(false);
                    }}>
                <i className="fa fa-file-excel"></i>
            </button>
        </div>
    </div>;
};

export default BYExportButtonsTable;
